import Vue from 'vue'

// 确保你使用的 Vuex 版本与你的 Vue 版本兼容。例如，Vuex 4 需要 Vue 3，而 Vuex 3 需要 Vue 2。
// 你可以在 package.json 中查看你的 Vue 和 Vuex 的版本，并确保它们是兼容的。
// npm install vuex@3.1.0 --save
// vuex@4.1.0 requires a peer of vue@^3.2.0 
import Vuex from 'vuex'  

// 安装vuex-persistedstate
// npm install vuex-persistedstate@3.2.1  （匹配vue2）
// import createPersistedState from 'vuex-persistedstate'  //持久化  

Vue.use(Vuex)

/**
 * 全局变量管理
 * store的状态管理
 * 使用的时候get方法和set方法分别是：
 * window.$store.commit('setDemoValue', value);
 * window.$store.getters.getDemoValue
 * 
 * 
 * State‌: 存储应用的共享状态（数据）。
 * ‌Getters‌: 类似于计算属性，用于从 State 中派生出新的状态。
 * ‌Mutations‌: 修改 State 的唯一途径，必须是同步函数。
 * ‌Actions‌: 用于提交 Mutations，可以包含异步操作（如网络请求）。
 * ‌Modules‌: 将 Store 拆分为模块，便于管理大型应用。
 */

const store = new Vuex.Store({
	strict: true,
	state: {
		cartGoodsCount:0, //购物车商品数量

		hasLogin: false,
		loginProvider: "",
		openId: null, 
		colorIndex: 0,
		colorList: ['#FF0000', '#00FF00', '#0000FF'],
		
	},
	// ...其他配置
	plugins: [
		// 暂不配置持久化
		// createPersistedState({
		// 	storage: window.localStorage, // 或 sessionStorage
		// 	key: 'my-app-store'
		// })
	],
	mutations: {
		// 通过 strict: true 可以开启严格模式,开启严格模式后，直接修改state中的值会报错 
		// state数据的修改只能通过mutations，并且mutations必须是同步的
		// 参数除state，只能是一个, 如果有多个参数要传, 可以传递一个对象
		// 页面调用：window.$store.commit('setCartGoodsCount', 6)
		setCartGoodsCount(state,count){
			state.cartGoodsCount=count;
		},

		login(state, provider) {
			state.hasLogin = true;
			state.loginProvider = provider;
		},
		logout(state) {
			state.hasLogin = false
			state.openId = null
		},
		setOpenid(state, openId) {
			state.openId = openId
		}
	},
	getters: {

		currentColor(state) {
			return state.colorList[state.colorIndex]
		}
	},
	actions: {
		// lazy loading openId
		getUserOpenId: async function({
			commit,
			state
		}) {
			return await new Promise((resolve, reject) => {
				if (state.openId) {
					resolve(state.openId)
				} else {
					//网络获取
				}
			})
		},
		getPhoneNumber: function({
			commit
		}, univerifyInfo) {
			return new Promise((resolve, reject) => {
				//网络获取
			})
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js